import { BaseModel } from "./BaseModel";
import { AxiosErr } from "../Contracts/IMdels";

export class UserModel extends BaseModel {
  RouteName = "Users";

  public async Token(model: object) {
    try {
      return await this.baseApi
        .axiosInstance()
        .post(`${this.RouteName}/Token`, model);
    } catch (e) {
      const error = e as AxiosErr;
      throw error.response?.data;
    }
  }
}
